import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { AffordabilityPageComponent } from './affordability.page';

const routes: Routes = [
  {
    component: AffordabilityPageComponent,
    path: ''
  }
];

@NgModule({
  exports: [RouterModule],
  imports: [RouterModule.forChild(routes)]
})
export class AffordabilityPageRoutingModule {}
